import { render, staticRenderFns } from "./ItemDetailLabour.vue?vue&type=template&id=d3aa026e&scoped=true"
import script from "./ItemDetailLabour.vue?vue&type=script&lang=js"
export * from "./ItemDetailLabour.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailLabour.vue?vue&type=style&index=0&id=d3aa026e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3aa026e",
  null
  
)

export default component.exports